module.exports = __webpack_public_path__ + "static/img/scrollImg0.57df070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scrollImg0.png
// module id = j9sK
// module chunks = 2